import React, { useEffect, FC } from "react";
import FormControl from "@material-ui/core/FormControl";
import {
  Checkbox,
  Popover,
  Snackbar,
  SnackbarContent,
} from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { TS_CHECK_RECORD, USERNGMAP, isDefaultMinusItem } from "./TSCheckTableDataOperation";
import { getFixedFlg } from "../../Header/Header";
import { stylesTSCheckTable } from "./StylesTSCheckRegister";

interface reasons {
  name: string;
  value: string;
}
const OTHER_VALUE: string = "99";

const TSCheckSelect: FC<{
  record: TS_CHECK_RECORD;
  reasonChange: (value: TS_CHECK_RECORD) => void;
}> = ({ record, reasonChange }) => {
  const classes = stylesTSCheckTable();
  const [targetAnchorEl, setTargetAnchorEl] = React.useState(null);
  const [checkedTargetValue, setCheckedTargetValue] = React.useState("");

  const [targetOpen, setTargetOpen] = React.useState(false);
  const targetId = targetOpen ? "target-popover" : undefined;
  const [openAlert, setOpenAlert] = React.useState(false);

  const alertClick = () => {
    setOpenAlert(!openAlert);
  };
  useEffect(() => {
    organizeNgList();
  }, []);

  // 詳細の更新
  const changeRadioComment = (val: string, event?: React.ChangeEvent) => {
    let checkedList: any[] = [];
    for (let i = 0; i < record.user_ng_list.length; i++) {
      if (checkedTargetValue === record.user_ng_list[i].user_radio_target) {
        let ngMap: USERNGMAP = {
          user_radio_target: record.user_ng_list[i].user_radio_target,
          user_radio_comment: val,
        };
        checkedList.push(ngMap);
      } else {
        checkedList.push(record.user_ng_list[i]);
      }
    }
    record.user_ng_list = checkedList;
    reasonChange(record);
  };

  // チェックリストの整理
  const organizeNgList = () => {
    let organizedNgList: any[] = [];
    for (let i = 0; i < record.user_ng_list.length; i++) {
      organizedNgList.push(record.user_ng_list[i]);
    }
    record.user_ng_list = organizedNgList;
    record.user_ng_list.sort(function (a, b) {
      if (a.user_radio_target > b.user_radio_target) return 1;
      if (a.user_radio_target < b.user_radio_target) return -1;
      return 0;
    });
  };

  // 該当箇所選択時
  const changeCheckTarget = (val: string, event: React.ChangeEvent) => {
    let checkedList: any[] = [];
    let addFlg = true;
    if (record.user_ng_list) {
      for (let i = 0; i < record.user_ng_list.length; i++) {
        if (val === record.user_ng_list[i].user_radio_target) {
          addFlg = false;
        } else {
          checkedList.push(record.user_ng_list[i]);
        }
      }
    }
    if (addFlg) {
      setCheckedTargetValue(val);
      let ngMap: USERNGMAP = {
        user_radio_target: val,
        user_radio_comment: "0",
      };
      checkedList.push(ngMap);
    }
    record.user_ng_list = checkedList;
    reasonChange(record);
    if (addFlg) {
      changeRadioComment("0");
      if (val === OTHER_VALUE) {
        setOpenAlert(true);
      }
      // setDetailOpen(true);
    }
  };
  const handleTargetClose = () => {
    organizeNgList();
    setTargetOpen(false);
  };
  const handleClick = (event: any) => {
    setTargetAnchorEl(event.currentTarget);
  };
  // ボタン押下処理
  const clickNgButton = (event: any, row: TS_CHECK_RECORD) => {
    if (getFixedFlg()) return;

    // デフォルトで「-」入力にする項目は該当箇所モーダルを表示しない
    if (isDefaultMinusItem(record.big_item_id, record.small_item_id)) return;

    // 該当箇所、詳細内容一覧がない場合
    if (!record.reason_target_list || record.reason_target_list.length === 0) {
      if (
        !record.reason_comment_list ||
        record.reason_comment_list.length === 0
      ) {
        reasonChange(record);
      } else {
        // setDetailOpen(true);
      }
    } else {
      setTargetOpen(true);
    }
  };

  const isCheckedTarget = (currentTarget: string) => {
    if (record.user_ng_list) {
      for (let i = 0; i < record.user_ng_list.length; i++) {
        if (currentTarget === record.user_ng_list[i].user_radio_target) {
          return true;
        }
      }
    }
    return false;
  };

  return (
    <>
      <Avatar
        className={
          classes.gray +
          " " +
          (record.button_value === "2" ? classes.ngMark : "")
        }
      >
        <IconButton
          onClick={(e) => {
            clickNgButton(e, record);
            handleClick(e);
          }}
        >
          <CloseIcon />
        </IconButton>
      </Avatar>
      {record.reason_target_list ? (
        <>
          <Popover
            open={targetOpen}
            id={targetId}
            onClose={handleTargetClose}
            anchorEl={targetAnchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Typography>
              <FormControl style={{ margin: 1, minWidth: 240 }}>
                <h4
                  style={{
                    margin: 0,
                    textAlign: "center",
                    backgroundColor: "sandybrown",
                  }}
                >
                  該当箇所
                </h4>
                {record.reason_target_list.map((reason: reasons) => (
                  <FormControlLabel
                    key={reason.value}
                    control={
                      <Checkbox
                        onChange={(e) => changeCheckTarget(reason.value, e)}
                        checked={isCheckedTarget(reason.value)}
                      />
                    }
                    label={reason.name}
                  />
                ))}
                {record.reason_target_list ? (
                  <FormControlLabel
                    key={OTHER_VALUE}
                    control={
                      <Checkbox
                        onChange={(e) => changeCheckTarget(OTHER_VALUE, e)}
                        checked={isCheckedTarget(OTHER_VALUE)}
                      />
                    }
                    label="その他"
                  />
                ) : (
                  ""
                )}
              </FormControl>
            </Typography>
          </Popover>

          <Snackbar
            open={openAlert}
            autoHideDuration={5000}
            onClose={alertClick}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <SnackbarContent
              style={{ backgroundColor: "#333333", color: "white" }}
              message={
                <span style={{ fontSize: "16px" }}>
                  {"その他の内容についてカメラボタンよりコメントに記載ください"}
                </span>
              }
            />
          </Snackbar>
        </>
      ) : (
        ""
      )}
    </>
  );
};
export default TSCheckSelect;
